import React, { useRef, useState, useEffect } from "react";
import Resizer from "react-image-file-resizer";
import { UploadCourseFile } from "./UploadCourseFile";
import "./courseImg.css";

const CourseImage = ({
  courseImageFileLimit,
  courseImageFile,
  editImageRef,
  history,
  uploadedFileID,
  isCourseBundle,
  isCurrentFileUploadStatus,
  isCurrentFileUpload,
}) => {
  const fileInputRef = useRef();
  const modalImageRef = useRef();

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [validFiles, setValidFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [validateError, setValidateError] = useState(false);
  const [showCourseImage, setShowCourseImage] = useState(false);

  useEffect(() => {
    var filteredArr = selectedFiles.reduce((file, current) => {
      const x = file.find((item) => item.name === current.name);
      if (!x) {
        return file.concat([current]);
      } else {
        return file;
      }
    }, []);
    setValidFiles([...filteredArr]);
    setValidateError(false);
  }, [selectedFiles]);

  useEffect(() => {
    if (editImageRef) {
      fileInputClicked();
    }
  }, [editImageRef]);

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const dragOver = (e) => {
    preventDefault(e);
  };

  const dragEnter = (e) => {
    preventDefault(e);
  };

  const dragLeave = (e) => {
    preventDefault(e);
  };

  const fileDrop = (e) => {
    preventDefault(e);
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  };

  const filesSelected = () => {
    if (fileInputRef.current.files.length) {
      handleFiles(fileInputRef.current.files);
    }
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };

  const handleFiles = (files) => {
    for (
      let i = 0;
      i < files.length && selectedFiles.length < courseImageFileLimit;
      i++
    ) {
      if (validateFile(files[i])) {
        try {
          Resizer.imageFileResizer(
            files[i],
            540,
            400,
            files[i].type.split("/")[1],
            100,
            0,
            (uri) => {
              setSelectedFiles((prevArray) => [...prevArray, uri]);
            },
            "file",
            540
          );
        } catch (err) {}
      } else {
        files[i]["invalid"] = true;
        setErrorMessage(
          "Sorry, that file type is not permitted. Please use PNG, JPG, JPEG, WEBP or GIF"
        );
        setValidateError(true);
      }
    }
  };

  const handleDeleteImage = () => {
    setSelectedFiles([]);
    setShowCourseImage(false);
    fileInputRef.current.value = "";
  };

  const validateFile = (file) => {
    const validTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (validTypes.indexOf(file.type) === -1) {
      return false;
    }

    return true;
  };

  const fileType = (fileName) => {
    return (
      fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length) ||
      fileName
    );
  };

  const removeFile = (name) => {
    const newSelectedFiles = selectedFiles.filter((el) => el.name !== name);
    setSelectedFiles(newSelectedFiles);
    courseImageFile(newSelectedFiles);
    fileInputRef.current.value = "";
    setShowCourseImage(false);
  };

  const openImageModal = (file) => {
    if (!file.invalid) {
      const reader = new FileReader();
      setShowCourseImage(true);

      reader.onload = function (e) {
        modalImageRef.current.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const closeModal = () => {
    setShowCourseImage(false);
  };

  const truncate = (str) => {
    return str.length > 10 ? str.substring(0, 30) + "..." : str;
  };

  const setFormState =
    (files) =>
    ({ key }) => {
      courseImageFile(isCourseBundle ? key : files);
    };

  return (
    <>
      <div className="course_main">
        <h3 className="course_heading">Upload your course image here</h3>
        <br />
        <h4 className="course_image-drop-text">
          Accepted image formats are PNG, JPG, JPEG, WEBP and GIF
        </h4>
        <div>
          <div
            className="course_image-drop-container"
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
            onClick={fileInputClicked}
          >
            <div className="course_drop-message">
              <div className="course_upload-icon"></div>
              <span className="course_image-drop-text">
                Drag and drop or browse to choose a file
              </span>
            </div>
            <input
              ref={fileInputRef}
              className="course_file-input"
              type="file"
              onChange={filesSelected}
              accept="image/jpeg, image/jpg, image/png, image/gif, image/webp"
            />
          </div>
          <div className="course_file-error-message">
            {validateError ? (
              <span className="course_file-error-message">
                ({errorMessage})
              </span>
            ) : null}
          </div>
          <div>
            {validFiles.map((data, i) => {
              return (
                <div key={i}>
                  <UploadCourseFile
                    storageType="CourseImages"
                    file={data}
                    openPreviewModal={openImageModal}
                    removeFile={removeFile}
                    setFormState={setFormState(validFiles)}
                    courseId={
                      history.location.state
                        ? history.location.state.courseId
                        : 0
                    }
                    fileID={uploadedFileID}
                    isCurrentFileUploadStatus={isCurrentFileUploadStatus}
                    isCurrentFileUpload={isCurrentFileUpload}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {showCourseImage && (
        <div className="course_modal-body imagePreviewViewer">
          <div className="align-image">
            <ul>
              <li>
                <img
                  src="https://cdn.edusity.com/icons/icon-refresh.svg"
                  alt=""
                />
              </li>
              <li>
                <img
                  onClick={handleDeleteImage}
                  src="https://cdn.edusity.com/icons/icon-trash.svg"
                  alt=""
                />
              </li>
            </ul>
          </div>

          <img
            id="fileframe"
            ref={modalImageRef}
            width="540px"
            height="300px"
          />
        </div>
      )}
    </>
  );
};

export default CourseImage;
